import { EventState, EventSubType, EventType, ExecuteEvent } from "pubsub/PubSub.const";
import IEvent from "./IEvent";
import { getInteractor } from "services/local.service";
import { EventDto, IEventDto } from "pubsub/dto";
import { refactorSavingEvent } from "pubsub/PubSub.helper";
import {
  accountDeleteService,
  syncAccountService,
  accountUpdateService,
  favoriteChatService,
} from "pubsub/services/account.service";

export default class AccountEvent extends IEvent {
  constructor(prefixKey: string) {
    super(prefixKey, EventType.ACCOUNT);
  }

  override handleEvent = async (limitRetry: number) => {
    const eventList: EventDto[] = (
      await getInteractor(this.prefixKey).LocalEventService.find({
        type: this.eventType,
        state: [EventState.NEW, EventState.RESENT, EventState.TIMEOUT],
      })
    ).map((item: IEventDto) => new EventDto(item));
    const savingEvents: IEventDto[] = [];
    for (let index = 0; index < eventList.length; index++) {
      const eventItem = eventList[index];
      const eventContent = eventItem.contentObj;
      const accountId = eventContent.account_id;
      const groupId = eventContent.group_id;
      let executeEventValue: ExecuteEvent = ExecuteEvent.FAIL;

      if (accountId) {
        switch (eventItem.subtype) {
          case EventSubType.NEW:
            executeEventValue = (await syncAccountService(this.prefixKey, accountId))
              ? ExecuteEvent.SUCCESSES
              : ExecuteEvent.RETRY;
            break;

          case EventSubType.UPDATE:
            executeEventValue = (await accountUpdateService(this.prefixKey, accountId))
              ? ExecuteEvent.SUCCESSES
              : ExecuteEvent.RETRY;
            break;

          case EventSubType.DELETE:
            executeEventValue = (await accountDeleteService(this.prefixKey, accountId))
              ? ExecuteEvent.SUCCESSES
              : ExecuteEvent.RETRY;
            break;

          case EventSubType.FAVORITE_CHAT:
            executeEventValue = await favoriteChatService(this.prefixKey, accountId, groupId);
            break;

          default:
            break;
        }
      }

      // Update event before saving in local db
      const refactorEvent = refactorSavingEvent(eventItem, executeEventValue, limitRetry);
      if (refactorEvent) savingEvents.push(refactorEvent);
    }

    await getInteractor(this.prefixKey).LocalEventService.save(savingEvents);
    return true;
  };
}
